/* TINOR horizontal slider: arrows + dots for scroll-snap tracks.
   Markup: [data-slider] > [data-slider-track] (children = slides),
   optional [data-slider-prev], [data-slider-next], [data-slider-dots]. */
(() => {
  function initSlider(root) {
    if (!root || root.dataset.sliderInit) return;
    const track = root.querySelector('[data-slider-track]');
    if (!track) return;
    root.dataset.sliderInit = '1';
    const slides = () => Array.from(track.children).filter(el => el.offsetWidth > 40);
    const dotsBox = root.querySelector('[data-slider-dots]');
    const prev = root.querySelector('[data-slider-prev]');
    const next = root.querySelector('[data-slider-next]');
    const label = dotsBox ? (dotsBox.dataset.label || 'Go to slide') : '';

    const index = () => {
      const s = slides();
      if (!s.length) return 0;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) return s.length - 1;
      const base = s[0].offsetLeft;
      let best = 0;
      s.forEach((el, i) => { if (Math.abs(el.offsetLeft - base - track.scrollLeft) < Math.abs(s[best].offsetLeft - base - track.scrollLeft)) best = i; });
      return best;
    };
    const go = (i) => {
      const s = slides();
      if (!s.length) return;
      i = Math.max(0, Math.min(s.length - 1, i));
      track.scrollTo({ left: s[i].offsetLeft - s[0].offsetLeft, behavior: 'smooth' });
    };

    let dots = [];
    const buildDots = () => {
      if (!dotsBox) return;
      const n = slides().length;
      dotsBox.innerHTML = '';
      dots = [];
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', label + ' ' + (i + 1));
        b.addEventListener('click', () => go(i));
        dotsBox.appendChild(b);
        dots.push(b);
      }
      dotsBox.hidden = n < 2;
    };
    const update = () => {
      const i = index();
      dots.forEach((d, j) => { d.classList.toggle('is-active', j === i); d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };

    prev && prev.addEventListener('click', () => go(index() - 1));
    next && next.addEventListener('click', () => go(index() + 1));
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', () => { buildDots(); update(); });
    buildDots();
    update();
    root.tinorSlider = { refresh() { buildDots(); update(); }, go };
  }

  const boot = (scope = document) => scope.querySelectorAll('[data-slider]').forEach(initSlider);
  window.TINORSlider = { init: initSlider, boot };
  boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
